<div class="loading" *ngIf="loading == true">Loading&#8230;</div>
<div class="advert-generate" id="advert-generate">
    <mat-card class="mb-3 tab-items">
        <mat-tab-group class="report-tab-group" [selectedIndex]="reportItemTabNumber - 1"
            (selectedIndexChange)="navigateToReportItemTab($event + 1)">
            <mat-tab *ngFor="let item of tabObject" [disabled]="item.isDisabled">
                <ng-template mat-tab-label class="bold">
                    <strong class="tab-title bold">
                        {{ item.value }}
                    </strong>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </mat-card>
    <app-advert-generate-developed *ngIf="reportItemTabNumber === 1" (stepCompleted)="goToPublishTab()"
        [selectedListing]="selectedListing" [listingType]="listingType" [selectedListingGroup]="selectedListingGroup"
        [sectorType]="developed"
        [doNotPublishPropertyUnderDevelopment]="doNotPublishPropertyUnderDevelopment"></app-advert-generate-developed>
    <app-advert-generate-developable *ngIf="reportItemTabNumber === 2" (stepCompleted)="goToPublishTab()"
        [selectedListing]="selectedListing" [listingType]="listingType" [selectedListingGroup]="selectedListingGroup"
        [sectorType]="developable"
        [doNotPublishPropertyUnderDevelopable]="doNotPublishPropertyUnderDevelopable"></app-advert-generate-developable>
    <app-advert-publish *ngIf="reportItemTabNumber === 3" [selectedListing]="selectedListing"
        [listingType]="listingType" [selectedListingGroup]="selectedListingGroup" [sectorType]="publish"
        [advertCreatorFiltersDto]="advertCreatorFiltersDto"></app-advert-publish>
    <mat-card class="floating-card">
        <button type="button" class="icon-button" matTooltip="Key">
            <mat-icon class="material-icons-outlined" (click)="openReportKeyDialog1()">info</mat-icon>
        </button>
        <button type="button" class="icon-button" matTooltip="Save" *ngIf="reportItemTabNumber !== 3" (click)="saveAdvertEntirely1()">
            <mat-icon class="material-icons-outlined">save</mat-icon>
        </button>
    </mat-card>
</div>